import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useId, useState } from "react";
import {
  getChipBackgroundColor,
  getMeasureColor,
} from "../../config/charts/sensorChart.config";

const MultipleSelect = ({
  onChange,
  isMobile,
  measureList,
  maxSelection = 3,
  isCurrent = false,
  value,
}) => {
  const [measure, setMeasure] = useState([]);
  const selectedMeasures = value ?? measure;
  const selectId = useId();

  const handleMeasureChange = (event) => {
    const newValue = event.target.value;

    if (newValue.length <= maxSelection) {
      setMeasure(newValue);
      onChange?.(newValue);
    }
  };

  const handleDelete = (valueToDelete, event) => {
    const newValue = selectedMeasures.filter((value) => value !== valueToDelete);
    setMeasure(newValue);
    onChange?.(newValue);
  };

  const getMeasureLabel = (value) => {
    const selectedMeasure = measureList.find((item) => item.value === value);
    return selectedMeasure?.label || value;
  };

  return (
    <FormControl sx={{ m: 1, width: isMobile ? "100%" : 300 }}>
      <InputLabel id={`${selectId}-label`}>Misure</InputLabel>
      <Select
        labelId={`${selectId}-label`}
        id={selectId}
        multiple
        value={selectedMeasures}
        onChange={handleMeasureChange}
        input={<OutlinedInput label="Misure" />}
        disabled={measureList.length === 0}
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              flexWrap: "nowrap",
              gap: 0.5,
              maxHeight: "60px",
              overflowX: "auto",
              overflowY: "hidden",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            {selected.map((value) => {
              const color = getMeasureColor(value, isCurrent, selectedMeasures);
              const label = getMeasureLabel(value);

              return (
                <Chip
                  key={value}
                  label={label}
                  onDelete={() => {}}
                  onMouseDownCapture={(event) => {
                    if (
                      event.target.tagName === "svg" ||
                      event.target.tagName === "path"
                    ) {
                      event.preventDefault();
                      handleDelete(value);
                    }
                  }}
                  sx={{
                    backgroundColor: getChipBackgroundColor(color),
                    color: color,
                    borderColor: color,
                    border: "1px solid",
                  }}
                />
              );
            })}
          </Box>
        )}
        sx={{ maxHeight: 100 }}
      >
        {measureList?.map((measureItem) => {
          const isSelected = selectedMeasures.includes(measureItem.value);
          const isDisable = selectedMeasures.length >= maxSelection && !isSelected;

          return (
            <MenuItem
              key={measureItem.value}
              value={measureItem.value}
              disabled={isDisable}
              sx={{
                ...(isDisable && {
                  color: "text.disabled",
                  backgroundColor: "action.hover",
                  opacity: 0.5,
                  "&:hover": {
                    backgroundColor: "action.hover",
                  },
                }),
              }}
            >
              {measureItem.label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default MultipleSelect;
